export default {
  heading: 'Purple Purse',
  body: 'Neucha, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Purple Purse',
  googleFonts: ['Purple Purse', 'Neucha']
  //   customFamilies: ['', ''],
  //   customUrls: ['', ''],
}
